// extracted by mini-css-extract-plugin
module.exports = {"shapeSelector":"ShapeSelector_shapeSelector__2IGxN","buttonGroup":"ShapeSelector_buttonGroup__3S1vw","button":"ShapeSelector_button__1prOD","active":"ShapeSelector_active__368As"};